import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./state/store";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
VueCookies.config("7d");

import webpage_header from "@/components/header";
Vue.component("webpage_header", webpage_header);

import webpage_nav from "@/components/navigation";
Vue.component("webpage_nav", webpage_nav);

Vue.config.productionTip = false;

Vue.prototype.$webpageEventBus = new Vue();

require("moment/locale/bs");

import sabira_icon from "@/components/sabira_icon";
Vue.use(sabira_icon);

// AXIOS
import axios from "axios";

// masonry
import VueMasonry from "vue-masonry-css";
Vue.use(VueMasonry);

import i18n from "./i18n";
import NumberFormatter from './numberFormatter';

Vue.filter('n', (value) => NumberFormatter.shared.n(value));
Vue.prototype.$n = (value) => NumberFormatter.shared.n(value);

axios.defaults.baseURL = process.env.VUE_BASE_URL;
Vue.prototype.$http = axios;
//Vue.use(axios);
Vue.prototype.$chart_colors = [
  "#6cadd8",
  "#61E294",
  "#F26419",
  "#F3D34A",
  "#8491d3",
  "#3ba272",
  "#fc8452",
  "#9a60b4",
  "#ea7ccc",
];

const moment = require("moment");

import helpers from "./helpers";
const helpers_plugin = {
  install() {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  },
};
Vue.use(helpers_plugin);
Vue.use(require("vue-moment"), {
  moment,
});

new Vue({
  router,
  vuetify,
  store,
  i18n,
  axios,
  render: (h) => h(App),
}).$mount("#app");

// console.log("*****************************************");
// console.log("Dobrodošli na SABIRA V.1.13");
// console.log("*****************************************");
